export const locale = {
  lang: 'en',
  data: {
    PROJECT_MANAGEMENT: {
      TITLE: 'Complete your carbon journey',
      BACK: 'Back',
      STEP: 'Step',
      TASKS: 'Tasks',
      COMPLETED: 'Completed',
      COMPLETED_SHORT: 'Completed',
      NO_QUESTIONS_STEP: 'No visible questions in this step yet.',
      ANSWER: 'Answer',
      QUESTION_TITLE: 'Question',
      STEP_MINI: 'Step',
      ANSWER_LABEL: 'Your answer',
      UNSUPPORTED_TYPE: 'Unsupported answer type',
      CANCEL: 'Cancel',
      PROCEED: 'Proceed',
      LOAD_FAILED: 'Project could not be loaded.',
      SAVED: 'Answer saved.',
      SAVE_FAILED: 'Could not save answer.',
      ANSWER_REQUIRED: 'Please complete the required fields.',
      INVALID_NUMBER: 'Enter a valid number.',
      PHASE_QUESTIONS_TITLE: 'Analysis',
      PHASE_QUESTIONS_SUB: 'Answer project questions to generate workflow tasks.',
      PHASE_TASKS_TITLE: 'Data collection',
      PHASE_TASKS_SUB: 'Track and complete tasks created from your answers.',
      PHASE_REPORT_TITLE: 'Report generation',
      PHASE_REPORT_SUB: 'Prepare your final output after completing tasks.',
      STAGES_LABEL: 'Stages',
      QUESTIONS_LABEL: 'questions',
      WORKFLOW_TASKS_LABEL: 'Tasks',
      PERCENT_DONE: 'Completed',
      TASKS_EMPTY: 'No tasks yet. Complete questions to create tasks.',
      TASKS_LOAD_FAILED: 'Tasks could not be loaded. You can still work on questions.',
      TASKS_LOADING: 'Loading tasks…',
      TASK_STATUS: 'Task status :',
      TASK_STATUS_COMPLETED: 'Completed',
      TASK_STATUS_IN_PROGRESS: 'In progress',
      TASK_STATUS_PENDING: 'Pending',
      NO_TASKS_IN_STEP: 'No tasks in this step yet.',
      TASK_STATUS_SAVED: 'Task status updated.',
      UPDATE_TASK_FAILED: 'Could not update task status.',
      PROJECT_COMPLETED_TASK_STATUS_LOCKED:
        'Task statuses cannot be changed because the project is completed.',
      URL_TASK_FLOAT_APPLY: 'Save status',
      URL_TASK_FLOAT_DONE: 'Mark completed',
      URL_TASK_FLOAT_HINT:
        'Drag the header to move. This panel follows URL-linked tasks from your active project.',
      URL_TASK_FLOAT_DISMISS: 'Close',
    },
  },
};
